import styled from 'styled-components';
import { StyledSearchRowContainer } from '../common/search-row.styles';
export const StyledQuerySearchRow = styled(StyledSearchRowContainer) `
  align-items: center;
  & .MuiGrid-container {
    display: block;
    flex: 0 1 500px;
    width: 100%;
  }

  & .MuiGrid-item {
    max-width: 100%;
  }

  & .search-input-container {
    border-radius: 8px 8px 0 0;
  }
`;
export const StyledCustomizeViewButtonWrapper = styled.div `
  margin-left: auto;
  width: 11.5rem;
  display: flex;
  justify-content: flex-start;

  && .MuiButton-root {
    height: 36px;
    padding: ${({ theme }) => `0 ${theme.spacing(2.4)} 0 0`};
    justify-content: flex-start;
  }

  .view-customize-icon {
    transform: rotate(180deg);
  }
`;
